import events from '../../../actions/event-names';
import Config from '../../../config';
import { showError, showSuccess, getExerciseTypeText } from '../../../utils'

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    ptList: [],
    isDetailsFetched: false,
    ptDetails: "",
    trainingModules: [],
    exercises: [],
    coachingList: [],
    taskOptions: [],
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_PT_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.ptList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_PT_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            ptList: [...state.ptList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_PT_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_PT_DETAILS}_PENDING`: {
        return {
            ...state,
            ptDetails: "",
            isDetailsFetched: 'PENDING',
            coachingList: [],
        };
    }
    case `${events.GET_PT_DETAILS_BG}_FULFILLED`: 
    case `${events.GET_PT_DETAILS}_FULFILLED`: {
        return {
            ...state,
            ptDetails: action.payload.data,
            taskOptions: action.payload.data.module.tasks.map((d) => {
                return {
                    label: d.title,
                    value: d.uuid
                }
            }),
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_PT_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //  DETAILS SAVE
    case `${events.SAVE_PT_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_PT_DETAILS}_PENDING`: {
        return {
            ...state,
            saveptDetails: 'PENDING',
        };
    }
    case `${events.SAVE_PT_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_PT_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            saveptDetails: 'FULFILLED',
        };
    }
    case `${events.SAVE_PT_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_PT_DETAILS}_REJECTED`: {
        return {
            ...state,
            saveptDetails: 'REJECTED',
        };
    }

  

    case `${events.ADD_NEW_PT}_PENDING`: {
        return {
            ...state,
            isNewptAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_PT}_FULFILLED`: {
        showSuccess("New progression table added successfully")
        return {
            ...state,
            isNewptAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_PT}_REJECTED`: {
        return {
            ...state,
            isNewptAdded: 'REJECTED',
        };
    }


    case `${events.DELETE_PT}_PENDING`: {
        return {
            ...state,
            isptDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_PT}_FULFILLED`: {
        showSuccess("Progression table deleted successfully")
        return {
            ...state,
            isptDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_PT}_REJECTED`: {
        return {
            ...state,
            isptDeleted: 'REJECTED',
        };
    }

    case `${events.GET_TRAINING_MODULES}_FULFILLED`: {
        return {
            ...state,
            trainingModules: action.payload.data.map((d) => {
                return {
                    label: d.title,
                    value: d.uuid
                }
            }),
        };
    }

    case `${events.GET_EXERCISES}_FULFILLED`: {
        return {
            ...state,
            exercises: action.payload.data.map((d) => {
                return {
                    label: d.name + ` (${getExerciseTypeText(d.workout_type)})`,
                    value: d.uuid
                }
            }),
        };
    }

    //GET_PT_COACHING_LIST
    case `${events.GET_PT_COACHING_LIST}_PENDING`: {
        return {
            ...state,
        };
    }
    case `${events.GET_PT_COACHING_LIST}_FULFILLED`: {
        return {
            ...state,
            coachingList: action.payload.data,
        };
    }
    case `${events.GET_PT_COACHING_LIST}_REJECTED`: {
        return {
            ...state,
        };
    }


    // ADD_NEW_PT_COACHING
    case `${events.ADD_NEW_PT_COACHING}_PENDING`: {
        return {
            ...state,
            isNewPtCoachingAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_PT_COACHING}_FULFILLED`: {
        showSuccess("New coaching successfully")
        return {
            ...state,
            isNewPtCoachingAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_PT_COACHING}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isNewPtCoachingAdded: 'REJECTED',
        };
    }

    // EDIT_PT_COACHING
    case `${events.EDIT_PT_COACHING}_PENDING`: {
        return {
            ...state,
            isPtCoachingUpdated: 'PENDING',
        };
    }
    case `${events.EDIT_PT_COACHING}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isPtCoachingUpdated: 'FULFILLED',
        };
    }
    case `${events.EDIT_PT_COACHING}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isPtCoachingUpdated: 'REJECTED',
        };
    }


    // DELETE_PT_COACHING
    case `${events.DELETE_PT_COACHING}_PENDING`: {
        return {
            ...state,
            isPtCoachingDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_PT_COACHING}_FULFILLED`: {
        showSuccess("Deleted successfully")
        return {
            ...state,
            isPtCoachingDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_PT_COACHING}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isPtCoachingDeleted: 'REJECTED',
        };
    }
    

    

    default:
        return state;
    }
}
